var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FdText',{attrs:{"colorLightGrey":"","fontSizeSmaller2":"","tag":"span"}},[_vm._v("Geomob © "+_vm._s(_vm.currentYear)+", by MONUNIVERT.FR")])
}
var staticRenderFns = []

export { render, staticRenderFns }